/*=========================================================================================
  File Name: moduleAccountsState.js
  Description: Accounts Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  roles: [],
  accounts: [],
  account: [],
  accounts_meta: null,
  roleIDs: [],
}
